import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';


@Component({
  selector: 'app-billing-country-filter',
  templateUrl: './billing-country-filter.component.html',
  styleUrls: ['./billing-country-filter.component.scss']
})
export class BillingCountryFilterComponent extends FilterAbstractModel
  implements OnInit, OnChanges, OnDestroy {

  listFilterData: any[];
  optionSelected: any = null;

  @Input() billingCountryData: any;
  @Input() billingCountrySelected: any;
                      
  constructor() {
    super();
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('billingCountryData' in changes) {
      this.listFilterData = this.billingCountryData ? this.billingCountryData : [];
      this.ensureSelectedValueInList();
      if (!this.optionSelected && !this.billingCountrySelected) {
        this.optionSelected = null;
      }
    }
    if ('billingCountrySelected' in changes) {
      this.optionSelected = this.billingCountrySelected || null;
      this.ensureSelectedValueInList();
    }
  }

  private ensureSelectedValueInList(): void {
    if (this.optionSelected && this.listFilterData && this.listFilterData.length > 0) {
      if (!this.listFilterData.includes(this.optionSelected)) {
        this.listFilterData = [...this.listFilterData, this.optionSelected];
      }
    }
  }

  ngOnDestroy(): void { }

}
